<div style="width: 70%">
  <div>
    <h3 style="float: left">Email templates</h3>
    <a id="add-new" [routerLink]="['/settings/template-editor']"
      ><i class="fa fa-plus-circle fa-lg"></i
    ></a>
  </div>
  <div style="clear: both">
    <p-table [value]="templates" showGridlines>
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'label.Name' | translate }}</th>
          <th>{{ 'label.Dates' | translate }}</th>
          <th>{{ 'label.Creator' | translate }}</th>
          <th style="width: 150px">{{ 'label.CreateDate' | translate }}</th>
          <th style="width: 24px"></th>
          <th style="width: 144px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{ template.name }}</td>
          <td>
            {{ template.validFrom | date : dateFormat }} -
            {{ template.validTo | date : dateFormat }}
          </td>
          <td>{{ template.createUser?.fullName }}</td>
          <td>{{ template.createDate | date : dateFormat }}</td>
          <td>
            <i
              class="fa fa-check"
              style="color: limegreen"
              *ngIf="template.statusId == PromoEmailTemplateStatusEnum.Approved"
            ></i>
          </td>
          <td>
            <div class="table-buttons">
              <a
                [routerLink]="[
                  '/settings/template-editor',
                  template.promoEmailTemplateId
                ]"
                ><i class="fa fa-edit fa-lg"></i
              ></a>
              <p-button
                type="button"
                (click)="onTemplateApprove(template)"
                icon="fa fa-check-square"
                [disabled]="
                  template.statusId == PromoEmailTemplateStatusEnum.Approved
                "
              ></p-button>
              <p-button
                type="button"
                (click)="onTemplateDelete(template)"
                icon="fa fa-times-circle"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
